var exports = {
  "tn": "dataRow__TIRTrM",
  "wZ": "dataRowValue__gt7Hxm",
  "Bb": "dataRowTitle__LuFD1s",
};

module.exports = exports;
